import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Heart, Gift, Users, Zap, Check, Plus } from 'lucide-react';
import { getApiUrl } from '../config/config';
import { useSiteSettings } from '../services/siteSettings';

const DiscordIcon = () => (<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-5.412 3.013a7.357 7.357 0 0 0 4.824 0 .046.046 0 0 0 .023-.06c-.461-1.3-1.61-2.29-2.435-2.29s-1.974.99-2.435 2.29a.046.046 0 0 0 .023.06zM15 4a8 8 0 0 1 4.5 2.5 8 8 0 0 1 2 4.5c0 3.5-1.5 6.5-4.5 8-1 .5-2 1-3 1s-2-.5-3-1c-3-1.5-4.5-4.5-4.5-8A8 8 0 0 1 8.5 6.5 8 8 0 0 1 13 4h2z"/></svg>);
const TelegramIcon = () => (<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>);

const HomeContainer = styled.div`min-height: 100vh; background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%);`;

const HeroSection = styled.section`
  padding: 120px 0 80px; text-align: center; position: relative; overflow: hidden;
  &::before { content: ''; position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: radial-gradient(circle at 30% 20%, rgba(224, 193, 111, 0.1) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(189, 133, 27, 0.05) 0%, transparent 50%); pointer-events: none; }
`;
const HeroContent = styled.div`max-width: 800px; margin: 0 auto; padding: 0 20px;`;
const HeroTitle = styled(motion.h1)`font-size: 4rem; font-weight: 800; font-family: var(--font-heading); color: #ffffff; margin-bottom: 24px; line-height: 1.1; position: relative; z-index: 2; @media (max-width: 768px) { font-size: 2.5rem; }`;
const HeroSubtitle = styled(motion.p)`font-size: 1.4rem; font-family: var(--font-body); color: #cccccc; margin-bottom: 50px; line-height: 1.5; position: relative; z-index: 2;`;

// --- TOTALNO POPRAVLJEN INPUT ZA TELEFONE I PC ---
const DomainInputContainer = styled.div`
  display: flex; align-items: center; max-width: 500px; margin: 0 auto; position: relative; z-index: 2; 
  background: #111; border: 2px solid #333; border-radius: 50px; transition: all 0.3s ease; 
  padding-left: 24px; /* Unutrašnji razmak za tekst */
  
  &:focus-within { border-color: #e0c16f; box-shadow: 0 0 0 3px rgba(224, 193, 111, 0.1); } 
  @media (max-width: 768px) { padding-left: 16px; }
`;

const DomainPrefix = styled.div`
  color: #ffffff; font-size: 1.1rem; font-weight: 800; font-family: var(--font-body); /* BELO I BOLD */
  display: flex; align-items: center; white-space: nowrap; margin-right: 4px; /* SKROZ BLIZU INPUTA */
  @media (max-width: 768px) { font-size: 1rem; }
`;

const DomainInput = styled(motion.input)`
  flex: 1; padding: 18px 0; background: transparent; border: none; color: #ffffff; font-size: 1.1rem; font-weight: 500; font-family: var(--font-body); outline: none; min-width: 0;
  &::placeholder { color: #666666; }
  @media (max-width: 768px) { padding: 14px 0; font-size: 1rem; }
`;

const ClaimButton = styled(motion.button)`
  padding: 14px 32px; margin: 6px; background: linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%); color: #000; border: none; border-radius: 46px; font-size: 1.1rem; font-weight: 700; font-family: var(--font-heading); cursor: pointer; transition: all 0.3s ease; white-space: nowrap;
  &:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(224, 193, 111, 0.3); } 
  @media (max-width: 768px) { padding: 10px 20px; font-size: 1rem; margin: 4px; }
`;

// --- OSTATAK STILOVA OSTAJE ISTI ---
const SectionContainer = styled.section`padding: 100px 0; position: relative; &::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 1px; background: linear-gradient(90deg, transparent, #e0c16f, transparent); }`;
const SectionTitle = styled(motion.h2)`text-align: center; font-size: 3rem; font-weight: 800; font-family: var(--font-heading); color: #ffffff; margin-bottom: 80px; @media (max-width: 768px) { font-size: 2.5rem; }`;
const Grid = styled.div`display: grid; grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr)); gap: 40px; max-width: 1200px; margin: 0 auto; padding: 0 20px; @media(max-width:600px){gap:20px;}`;

const FeatureCard = styled(motion.div)`background: #111; border: 2px solid #333; border-radius: 20px; padding: 50px 30px; text-align: center; transition: all 0.3s; position: relative; overflow: hidden; &::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; background: linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%); transform: scaleX(0); transition: transform 0.3s; } &:hover { border-color: #e0c16f; transform: translateY(-8px); &::before { transform: scaleX(1); } }`;
const FeatureIcon = styled.div`width: 90px; height: 90px; background: linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 30px; color: #000;`;
const FeatureTitle = styled.h3`font-size: 1.6rem; color: #fff; margin-bottom: 20px;`;
const FeatureDescription = styled.p`color: #ccc; line-height: 1.6; font-size: 1.1rem;`;

const PricingCard = styled(motion.div)`background: ${p => p.featured ? 'linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%)' : '#111'}; color: ${p => p.featured ? '#000' : '#fff'}; border: 3px solid ${p => p.featured ? '#e0c16f' : '#333'}; border-radius: 25px; padding: 50px 30px; text-align: center; position: relative; transition: all 0.3s; &:hover { transform: translateY(-8px); }`;
const PlanFeatures = styled.ul`list-style: none; margin-bottom: 32px; padding:0; li { padding: 8px 0; display: flex; align-items: center; justify-content: center; gap: 8px; }`;
const SelectPlanButton = styled.button`width: 100%; padding: 18px 24px; background: ${p => p.featured ? '#000' : 'linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%)'}; color: ${p => p.featured ? '#e0c16f' : '#000'}; border: none; border-radius: 15px; font-weight: 700; cursor: pointer;`;

const FAQItem = styled(motion.div)`background: #111; border: 1px solid #333; border-radius: 12px; margin-bottom: 16px; overflow: hidden;`;
const FAQQuestion = styled.button`width: 100%; padding: 24px; background: transparent; border: none; color: #fff; text-align: left; font-size: 1.1rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: space-between;`;
const FAQAnswer = styled(motion.div)`padding: 0 24px; overflow: hidden; p { color: #ccc; line-height: 1.6; margin: 0; padding-bottom: 24px; }`;

const SocialSection = styled.div`
  display: flex; justify-content: center; gap: 24px; margin-top: 60px;
`;
const SocialIconBtn = styled.a`
  display: flex; align-items: center; justify-content: center; width: 60px; height: 60px;
  background: #111; border: 2px solid #333; border-radius: 50%; color: #888;
  transition: all 0.3s;
  &:hover {
    color: #e0c16f; border-color: #e0c16f; transform: translateY(-5px); box-shadow: 0 10px 20px rgba(224, 193, 111, 0.2);
  }
`;


const HomePage = () => {
  const [domainName, setDomainName] = useState('');
  const [openFAQ, setOpenFAQ] = useState(null);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterMessage, setNewsletterMessage] = useState('');
  const navigate = useNavigate();
  const site = useSiteSettings();

  const handleClaimDomain = () => {
    if (domainName.trim()) {
      // Vodi te direktno na stranicu za signup gde će username biti popunjen
      navigate(`/signup?username=${domainName.trim()}`);
    }
  };
  
  // DODAJ 
  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  // Svi tvoji podaci za FAQ, Usluge i Planove ostaju isti
  const faqData = [
    { question: "What is BUCX?", answer: "BUCX is a platform that connects creators with their fans, enabling them to earn money from their content and engage directly with their audience. It provides tools and infrastructure for creators to build their brand, manage their community, and monetize their content." },
    { question: "How does BUCX make money?", answer: "BUCX generates revenue primarily through platform fees, which include transaction fees for payments, subscription fees for memberships, and commission fees for sales of products. The platform also offers premium features and services that creators can monetize directly." },
    { question: "Is BUCX free to use?", answer: "Yes, BUCX is free to use for creators. You can create your profile, engage with your community, and earn money from your content without any upfront costs. The platform is designed to be accessible to everyone." },
    { question: "How do creators earn money on BUCX?", answer: "Creators can earn money in several ways on BUCX: one-time donations, monthly memberships, sales of digital products (like e-books, courses, etc.), and commissions from sales of physical products. The platform offers flexible monetization options to suit different content types and goals." },
    { question: "What types of content can I create on BUCX?", answer: "BUCX supports a wide variety of content types including digital art, music, videos, written content, courses, tutorials, and more. The platform is designed to be flexible and accommodate different creative mediums and styles." },
    { question: "How do I get started as a creator?", answer: "Getting started is easy! Simply sign up for an account, complete your creator profile setup, and start sharing your content. You can begin accepting donations immediately and set up additional monetization options as you grow your audience." }
  ];

  const features = [
    { icon: <Heart size={40}/>, title: "Support Creators", description: "Show your appreciation with one-time donations or monthly memberships" },
    { icon: <Gift size={40}/>, title: "Exclusive Content", description: "Access special content, early releases, and behind-the-scenes material" },
    { icon: <Users size={40}/>, title: "Community", description: "Join creator communities and connect with like-minded supporters" },
    { icon: <Zap size={40}/>, title: "Instant Support", description: "Quick and secure payments with multiple payment options" }
  ];

  const plans = [
    { name: "Contributor", price: "$0", period: "per month", features: ["Receive donations or tips", "Offer memberships", "Sell products", "Take commissions", "5% Platform Fee"], featured: false },
    { name: "Gold", price: "$25", period: "per month", features: ["All contributor features", "Advanced analytics", "Priority support", "Custom branding", "No Platform Fee!"], featured: true }
  ];

  const subscribeNewsletter = async () => {
    setNewsletterMessage('');
    try {
      const response = await fetch(`${getApiUrl()}/site/newsletter`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:newsletterEmail})});
      const data = await response.json();
      setNewsletterMessage(data.message || data.error);
      if (response.ok) setNewsletterEmail('');
    } catch { setNewsletterMessage('Newsletter signup is not available yet.'); }
  };

  return (
    <HomeContainer>
      <HeroSection>
        <HeroContent>
          <HeroTitle initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            Everything you need to make money doing what you love
          </HeroTitle>
          <HeroSubtitle initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}>
            Join 1M+ creators getting donations, monthly memberships and sales from fans!
          </HeroSubtitle>
          
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }}>
            <DomainInputContainer>
              <DomainPrefix>bucx.io/</DomainPrefix>
              <DomainInput
                type="text"
                placeholder="yourname"
                value={domainName}
                onChange={(e) => setDomainName(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleClaimDomain()}
              />
              <ClaimButton onClick={handleClaimDomain}>Claim</ClaimButton>
            </DomainInputContainer>
          </motion.div>
        </HeroContent>
      </HeroSection>

      <SectionContainer>
        <SectionTitle>Platform Features</SectionTitle>
        <Grid>
          {features.map((feature, index) => (
            <FeatureCard key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: index * 0.1 }} viewport={{ once: true }}>
              <FeatureIcon>{feature.icon}</FeatureIcon>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </Grid>
      </SectionContainer>

      <SectionContainer>
        <SectionTitle>BUCX Pricing</SectionTitle>
        <p style={{textAlign: 'center', fontSize: '1.2rem', color: '#ccc', marginBottom: '60px'}}>Creating your BUCX account is totally free!</p>
        <Grid>
          {plans.map((plan, index) => (
            <PricingCard key={index} featured={plan.featured} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              {plan.featured && <div style={{position: 'absolute', top: '-15px', left: '50%', transform: 'translateX(-50%)', background: '#000', color: '#e0c16f', padding: '10px 25px', borderRadius: '25px', fontWeight: 'bold'}}>Most Popular</div>}
              <h3 style={{fontSize: '1.5rem', marginBottom: '16px'}}>{plan.name}</h3>
              <div style={{fontSize: '3rem', fontWeight: 'bold', marginBottom: '8px'}}>{plan.price}</div>
              <div style={{opacity: 0.7, marginBottom: '24px'}}>{plan.period}</div>
              <PlanFeatures>
                {plan.features.map((feat, i) => <li key={i}><Check size={20} color={plan.featured ? '#000' : '#e0c16f'}/> {feat}</li>)}
              </PlanFeatures>
              <SelectPlanButton featured={plan.featured} onClick={() => navigate('/signup')}>Select Plan</SelectPlanButton>
            </PricingCard>
          ))}
        </Grid>
      </SectionContainer>

      <SectionContainer>
        <SectionTitle>LET'S CONNECT</SectionTitle>
        <p style={{textAlign: 'center', fontSize: '1.3rem', color: '#ccc', marginBottom: '40px'}}>Subscribe To Our Newsletter</p>
        <div style={{display: 'flex', flexWrap:'wrap', justifyContent: 'center', gap: '16px', maxWidth: '500px', margin: '0 auto'}}>
          <input type="email" value={newsletterEmail} onChange={e=>setNewsletterEmail(e.target.value)} placeholder="Enter your email" style={{flex: '1 1 250px', minWidth:0, padding: '18px 24px', background: '#111', border: '2px solid #333', borderRadius: '50px', color: '#fff'}} />
          <ClaimButton style={{margin: 0}} onClick={subscribeNewsletter}>Subscribe</ClaimButton>
        </div>
        {newsletterMessage && <p style={{textAlign:'center',color:'#e0c16f',marginTop:'14px'}}>{newsletterMessage}</p>}

        {/* SOCIAL LINKS (Zameni linkove sa pravim BUCX linkovima) */}
        <SocialSection>
          {site.discord_url && <SocialIconBtn href={site.discord_url} target="_blank" rel="noreferrer" aria-label="Join our Discord">
            <DiscordIcon />
          </SocialIconBtn>}
          {site.telegram_url && <SocialIconBtn href={site.telegram_url} target="_blank" rel="noreferrer" aria-label="Join our Telegram">
            <TelegramIcon />
          </SocialIconBtn>}
        </SocialSection>
      </SectionContainer>

      <SectionContainer>
        <div style={{maxWidth: '800px', margin: '0 auto', padding: '0 20px'}}>
          <SectionTitle>Frequently Asked Questions</SectionTitle>
          {faqData.map((item, index) => (
            <FAQItem key={index}>
              <FAQQuestion onClick={() => toggleFAQ(index)}>
                {item.question}
                <Plus style={{transform: openFAQ === index ? 'rotate(45deg)' : 'rotate(0deg)', transition: '0.3s', color: '#e0c16f'}} />
              </FAQQuestion>
              <AnimatePresence>
                {openFAQ === index && (
                  <FAQAnswer initial={{height: 0}} animate={{height: 'auto'}} exit={{height: 0}}>
                    <p>{item.answer}</p>
                  </FAQAnswer>
                )}
              </AnimatePresence>
            </FAQItem>
          ))}
        </div>
      </SectionContainer>

    </HomeContainer>
  );
};

export default HomePage;
